module.exports = __webpack_public_path__ + "img/ImageQstep2.6a226830.png";